import type { DropdownData } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { list } from 'src/app/common/classes/request-builder';
import { ComunidadesRegantesModel } from 'src/app/models/analisis/comunidadesRegantes.model';
import { SectorModel } from 'src/app/models/form-common/sector.model';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { MaquinariaModel } from 'src/app/models/trabajadores/maquinaria.model';
import { VisitasVariedadMesModel } from 'src/app/models/visitas_variedad_mes/visitas_variedad_mes.model';

export class FertirrigacionListsDefinition {
    public fincas: DropdownData<FincasModel> = list<FincasModel>();

    public sectores: DropdownData<SectorModel> = list<SectorModel>();

    public parcelas: DropdownData<ParcelasModel | ParcelasModel[]> = list<ParcelasModel | ParcelasModel[]>();

    public sistemasRiego: DropdownData<string> = list<string>();

    public maquinarias: DropdownData<MaquinariaModel> = list<MaquinariaModel>();
    
    public comunidadesRegantes: DropdownData<ComunidadesRegantesModel> = list<ComunidadesRegantesModel>();

    public cultivos: DropdownData<VisitasVariedadMesModel> = list<VisitasVariedadMesModel>(['...', null]);
}